// src/services/actionApi.js
// CRUD de acciones por rol (action.php)
// GET action.php/123 → role_id 123 (menú jerárquico). PUT/DELETE action.php/{id} → id_role_action.

import { dotoniwoofApi } from '../api/dotoniwooApi';

/**
 * Lista todas las acciones (plano).
 * GET action.php o action.php?role_id=2
 * @param {number} [roleId] - Filtrar por rol
 */
export const getActions = async (roleId = null) => {
  try {
    const url = roleId != null ? `/action.php?role_id=${roleId}` : '/action.php';
    const response = await dotoniwoofApi.get(url);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al listar acciones:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Una acción por ID_ROLE_ACTION.
 * GET action.php?id=123
 */
export const getActionById = async (id) => {
  try {
    const response = await dotoniwoofApi.get(`/action.php?id=${id}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener acción:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Acciones del rol en estructura jerárquica (padre/hijos).
 * GET action.php/123 → 123 = role_id (mismo uso que antes para el menú).
 */
export const getActionsByRoleHierarchical = async (roleId) => {
  try {
    const response = await dotoniwoofApi.get(`/action.php/${roleId}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener acciones del rol:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Crear acción.
 * POST action.php
 * Body: role_id (obligatorio), action_name (obligatorio), url, parent_action_id, icon, order_index
 */
export const createAction = async (body) => {
  try {
    const response = await dotoniwoofApi.post('/action.php', body);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al crear acción:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Actualizar acción por ID_ROLE_ACTION.
 * PUT action.php/{id} → id = id_role_action
 */
export const updateAction = async (idRoleAction, body) => {
  try {
    const response = await dotoniwoofApi.put(`/action.php/${idRoleAction}`, body);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al actualizar acción:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Borrar acción por ID_ROLE_ACTION.
 * DELETE action.php/{id} → id = id_role_action
 */
export const deleteAction = async (idRoleAction) => {
  try {
    const response = await dotoniwoofApi.delete(`/action.php/${idRoleAction}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al eliminar acción:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};
